import {createContext, PropsWithChildren, useMemo} from 'react';
import {useQuery} from '@tanstack/react-query';
import {useChekinSDK} from '../ChekinSDK';
import {QUERY_CACHE_KEYS} from '../../utils/constants';
import {IpDetails} from '@guestapp/sdk';

type ContextProps = {
  ipDetails?: IpDetails;
};

const IpDetailsContext = createContext<ContextProps>({});

function IpDetailsProvider(props: PropsWithChildren) {
  const {getIpDetails, isSuccessSDK} = useChekinSDK();
  const {data} = useQuery<IpDetails>([QUERY_CACHE_KEYS.ipDetails], () => getIpDetails(), {
    refetchOnWindowFocus: false,

    refetchOnMount: false,
    enabled: isSuccessSDK,
  });

  const value: ContextProps = useMemo(
    () => ({
      ipDetails: data,
    }),
    [data],
  );

  return <IpDetailsContext.Provider {...props} value={value} />;
}

export {IpDetailsProvider, IpDetailsContext, type ContextProps};
